import { render, staticRenderFns } from "./fwtaobao.vue?vue&type=template&id=62342147&scoped=true&"
import script from "./fwtaobao.vue?vue&type=script&lang=js&"
export * from "./fwtaobao.vue?vue&type=script&lang=js&"
import style0 from "./fwtaobao.vue?vue&type=style&index=0&id=62342147&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62342147",
  null
  
)

export default component.exports